import { env } from '../config/env';

const AUTH_API_URL = env.AUTH_API_URL;
const FINAPI_API_URL = env.FINAPI_API_URL;

export const API_URLS = {
  auth: {
    loginRedirectUrl: `${AUTH_API_URL}/api/auth/login`,
    logoutRedirectUrl: `${AUTH_API_URL}/api/auth/logout`,
    exchangeAuthCode: `${AUTH_API_URL}/api/auth/exchange`,
    refreshToken: `${AUTH_API_URL}/api/auth/refresh`,
    getSideBarData: `${AUTH_API_URL}/api/menu`,
    getCompetenceDate: `${FINAPI_API_URL}/api/competencia`,
    accessProfile: `${AUTH_API_URL}/api/profiles`,
    permissions: `${AUTH_API_URL}/api/permissions`,
    users: `${AUTH_API_URL}/api/users`,
    budgetFy27ValidationStatus: `${AUTH_API_URL}/security/api/budget/fy27-validation-status`
  },
  finapi: {
    invoicing: `${FINAPI_API_URL}/api/faturamentoagrupado`,
    consumption: `${FINAPI_API_URL}/api/consumo`,
    consumptionV2: `${FINAPI_API_URL}/api/v2/consumo`,
    otherExpenses: `${FINAPI_API_URL}/api/outrasdespesas`,
    depreciation: `${FINAPI_API_URL}/api/depreciacao`,
    preview: `${FINAPI_API_URL}/api/previa`,
    previaapproval: `${FINAPI_API_URL}/api/previaapproval`,
    people: `${FINAPI_API_URL}/api/pessoal`,
    peopleV2: `${FINAPI_API_URL}/api/v2/pessoal`,
    deviationJustification: `${FINAPI_API_URL}/api/deviationjustification`,
    consolidatedEntry: `${FINAPI_API_URL}/api/lancamentoconsolidado`,
    previewManagement: `${FINAPI_API_URL}/api/previa/management`,
  },
}

